<template>
  <div>
    <div class="pay-image-header">
      <img src="../assets/china-bank.png" alt='loading'></img>
    </div>

    <div class="pay-image-header">
      <img class="b-bank" src="../assets/banner.jpg" alt='loading'></img>
      <img class="net-bank" src="../assets/login-bocnet.png" alt='loading'></img>
    </div>

    <div class="login">
      <div class="login-top"></div>
      <div class="login-middle-new">
        <div class="login-header">
          <span class="login-title">User Login</span>
        </div>
        <el-form class="login-form" :model="loginViewModel" id="login-form" :rules="loginViewModelRules" ref="loginViewForm">
          <el-form-item prop="userName">
            <label class="el-form-item-label label1">User Name</label>
            <input maxLength="20" class="login-form-field  a3" type="text" v-model="loginViewModel.userName" auto-complete="off"></input>
          </el-form-item>
          <el-form-item prop="passWord">
            <label class="el-form-item-label label2">Password</label>
            <sip-edit :id="keyboardData[0].id" :keyboardType="keyboardData[0].type" :attr="keyboardData[0].attrs" :ref="keyboardData[0].id"
              @onJsLoad="onJsLoad" />
          </el-form-item>
          <el-form-item prop="netToken">
            <label class="el-form-item-label label3">E-token</label>
            <sip-edit :id="keyboardData[1].id" :keyboardType="keyboardData[1].type" :attr="keyboardData[1].attrs" :ref="keyboardData[1].id"
              @onJsLoad="onJsLoad" />
          </el-form-item>
          <el-form-item prop="code" id="divcode">
            <label class="el-form-item-label label4">Certification Code</label>
            <input maxLength="4" class="login-form-field-ceri a4" type="text" v-model="loginViewModel.code" auto-complete="off"></input>
            <img class="authcode-base64" :src="'data:image/png;base64,'+authCodeBase64" alt='loading' @click="getCaptcha"></img>
            <span class="ceri">Not Case Sensitive</span>
            <div class="change-ceri" @click="getCaptcha">Change Certification Code</div>
          </el-form-item>

          <el-form-item>
            <el-button class="button-login a6" type="danger" :loading="loadFlag" @click="loginBtn">Login</el-button>
            <el-button class="button-cancel" type="danger" @click="cancel">Cancel</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>

    <div class="pro">
      <div>
        <span class="pone">Security Information:
          <br/>
        </span>
      </div>
      <div class="ptwo">
        <span class="dto1">.</span>Click
        <a href="https://www.bankofchina.com.my/en-my/segment/personal-banking/security-tips.html" target="_self">here</a>
        <span> for security tips router to website</span>
      </div>
      <div class="pthree">
        <span class="dto2">.</span>Never reveal your PIN and/or Password to anyone
      </div>
    </div>
    <ExpirTime ref="expirTime" :startAction="true" @timeoutStatus="timeoutStatus"></ExpirTime>
    <Dialog :dialogVisible="dialogVisible" :errorMessage="errorMessage" @dialogClose="dialogClose"></Dialog>
    <DialogCancel :cancelVisible="cancelVisible" :buttonAble="buttonAble" @cancelDialogClose="cancelDialogClose" @cancelTran="cancelTran"></DialogCancel>

    <div class="bottom">
      <span>Support IPv6 network</span>
    </div>
  </div>


</template>

<script>
  import ExpirTime from '../views/ExpirTime'
  import Dialog from '../views/Dialog'
  import DialogCancel from '../views/DialogCancel'
  import service from '@service/service'
  import SipEdit, {
    KEYBOARD_TYPE,
    OUTPUTTYPE,
    CIPHERTYPE,
    SERVERRANDOM_CIPHERTYPE,
    PUBLICKEYTOENCRYPT,
    RANDOMTYPE,
  } from '@/views/SipEdit';
  //由网银返回服务器端随机数，测试时由客户端生成
  const RANDOM = 'MTIzNDU2Nzg5MDk4NzY1NA==';
  const KEYBOARD_TITLE = '安全控件1（系统键盘）';
  export default {
    components: {
      SipEdit, ExpirTime: ExpirTime, Dialog, DialogCancel
    },
    name: "Login",
    data() {
      return {
        gapTime: 0,
        beforTime: 0,
        loadFlag: false,
        dialogVisible: false,
        cancelVisible: false,
        buttonAble: false,
        errorMessage: '',
        loginViewModel: {
          userName: '',
          passWord: '',
          clientRandom: '',
          netToken: '',
          tokenRandom: '',
          orderReference: '',
          serverRandom: '',
          code: '',
          codeIndex: '',
          activ: '',
        },
        serverRandom: '',
        orderDetail: {
          sellerDesc: '',
          fpxTransId: '',
          transAmount: '',
          transCurrency: '',
          feeAmount: '',
          feeCurrency: ''
        },
        authCodeBase64: '',
        isUserAdmin: false,
        loginViewModelRules: {
          userName: { required: true, message: 'Please Input User Name', trigger: 'change' },
          passWord: { required: true, message: 'Please Input Password', trigger: 'change' },
          netToken: { required: true, message: 'Please Input E-Token', trigger: 'change' },
          code: { required: true, message: 'Please Input Certification Code', trigger: 'change' }
        },
        keyboardTitle: KEYBOARD_TITLE,
        logData: '',
        placeholder1: 'Password',
        placeholder2: 'E-Token',
        timerStatus: false,
        keyboardData: [
          {
            type: KEYBOARD_TYPE.SIP_TYPE_SYSTEM_KEYBOARD,
            id: 'sipKeyboar1',
            title: KEYBOARD_TITLE,
            attrs: this.initAttrs(),
          },
          {
            type: KEYBOARD_TYPE.SIP_TYPE_SYSTEM_KEYBOARD,
            id: 'sipKeyboar2',
            title: KEYBOARD_TITLE,
            attrs: this.initAttrs(),
          },
        ]
      }
    },

    beforeCreate() {
      let token = window.location.hash;
      let start = token.indexOf("token=");
      if (start == -1) {
        this.$router.replace({ path: '/tokenError' })
      } else {
        token = token.slice(start + 6);
        if (token == undefined || token == null || token == "") {
          this.$router.replace({ path: '/tokenError' })
        } else {
          window.sessionStorage.setItem('sessionToken', token)
        }
      }

      let pageCount = window.sessionStorage.getItem('pageCount')
      if (pageCount == undefined || pageCount == null) {
        pageCount = 1;
        window.sessionStorage.setItem('pageCount', pageCount)
      } else {
        pageCount++;
        window.sessionStorage.setItem('pageCount', pageCount)
      }
    },

    created() {
      let self = this
      document.onkeypress = function (e) {
        var keyCode = document.all ? event.keyCode : e.which
        if (keyCode == 13) {
          self.loginBtn()
          return false
        }
      }
      if (window.sessionStorage.getItem('sessionToken')) {
        this.getOrderInfo();
      }
    },


    mounted() {
        window.addEventListener("beforeunload",() => this.beforeunloadHandler());
        window.addEventListener("unload",() => this.unloadHandler());
        if( window.history && window.history.pushState ) {
           history.pushState(null,null,document.URL);
           window.addEventListener("popstate",() => this.pageBeforeHandler());
        }
    },

    destroyed(){
        window.removeEvenListener("beforeunload",() => this.beforeunloadHandler());
        window.removeEvenListener("unload",() => this.unloadHandler());
        window.removeEvenListener("popstate",() => this.pageBeforeHandler());
    },


    methods: {
      pageBeforeHandler(){
           let opxpPayNo  = window.sessionStorage.getItem('opxpPaymentNo');
           this.$http.post(service.opxpPayFailure, {
              statusCode: '1C',
              opxpPaymentNo: opxpPayNo
          }).then((res) => {
              console.log("send 1c msg");
          }).catch(error => {
              console.log("send 1c error");
          })
      },
      beforeunloadHandler(){
         this.beforTime = new Date().getTime();
         this.unloadHandler();
      },
      unloadHandler(){
        this.gapTime = new Date().getTime()-this.beforTime;
        if( this.gapTime < 5) {
           let opxpPayNo  = window.sessionStorage.getItem('opxpPaymentNo');
           this.$http.post(service.opxpPayFailure, {
             statusCode: '1C',
             opxpPaymentNo: opxpPayNo
           }).then((res) => {
              console.log("send 1c msg");
           }).catch(error => {
              console.log("send 1c error");
           })
        }else {
          console.log("this is refresh");
        }
      },

      timeoutStatus(status) {
        this.timerStatus = status;
        if (this.timerStatus == true) {
          window.sessionStorage.setItem('statusCode', "1A")
        }
      },

      initAttrs() {
        const attrs = {};
        attrs.cipherType = CIPHERTYPE.CIPHER_TYPE_RSA;
        attrs.minLength = 1;
        attrs.maxLength = 20;
        attrs.outputType = OUTPUTTYPE.OUTPUT_TYPE_HASH;
        attrs.serverRandomCipherType = SERVERRANDOM_CIPHERTYPE.SERVERRANDOM_CIPHER_TYPE_3DES;
        attrs.publicKeyToEncrypt = PUBLICKEYTOENCRYPT.PUBLIC_KEY_EBANK;
        attrs.random = RANDOM;
        attrs.randomType = RANDOMTYPE.RANDOM_NONE;
        attrs.inputRegex = '\\S';
        return attrs;
      },

      onJsLoad() {
        for (let index = 0; index < this.keyboardData.length; index += 1) {
          const id = this.keyboardData[index].id;
          if (id == 'sipKeyboar1') {
            this.$refs[id].initKeyboard();
          }

          if (id == 'sipKeyboar2') {
            this.$refs[id].initKeyboard1();
          }
        }
      },

      getOrderInfo() {
        this.$http.post(service.orderInfo).then(res => {
          window.sessionStorage.setItem('opxpPaymentNo', res.opxpPaymentNo);
          window.sessionStorage.setItem('indirectURL', res.indirectURL);

          this.getServerRandom();
          this.getCaptcha();
        }).catch(error => {
          window.sessionStorage.setItem('statusCode', "1B")
          window.sessionStorage.setItem('message', "You have cancelled your login.")
          if (error.message === 'Token verify fail') {
            this.$router.replace({ path: '/tokenError' })
          }
          this.dialogVisible = true;
          this.errorMessage = error.message;
        })

      },

      getServerRandom() {
        this.$http.post(service.serverRandom).then(res => {
          this.serverRandom = res.rs;
          this.loginViewModel.serverRandom = res.rs;

        }).catch(error => {
          window.sessionStorage.setItem('statusCode', "1B")
          window.sessionStorage.setItem('message', "You have cancelled your login.")
          if (error.message === 'Token verify fail') {
            this.$router.replace({ path: '/tokenError' })
          }
          this.dialogVisible = true;
          this.errorMessage = error.message;
        })

      },

      getCaptcha() {
        this.$http.post(service.captcha).then((res) => {
          this.loginViewModel.codeIndex = res.id
          this.authCodeBase64 = res.base64Image
        }).catch(error => {
          window.sessionStorage.setItem('statusCode', "1B")
          window.sessionStorage.setItem('message', "You have cancelled your login.")
          if (error.message === 'Token verify fail') {
            this.$router.replace({ path: '/tokenError' })
          }
          this.dialogVisible = true;
          this.errorMessage = error.message;
        })
      },

      getEncryptData() {
        if (this.serverRandom == undefined || this.serverRandom == null || this.serverRandom == '') {
          this.dialogVisible = true;
          this.errorMessage = 'Connection fail,Please refresh';
          return false;
        }

        this.$refs[this.keyboardData[0].id].setServerRandom(this.serverRandom);
        this.$refs[this.keyboardData[1].id].setServerRandom1(this.serverRandom);

        const encryptInputData = this.$refs[this.keyboardData[0].id].getEncryptedInputValue();
        const encryptRandomData = this.$refs[this.keyboardData[0].id].getEncryptedClientRandom();
        const encryptInputData1 = this.$refs[this.keyboardData[1].id].getEncryptedInputValue1();
        const encryptRandomData1 = this.$refs[this.keyboardData[1].id].getEncryptedClientRandom1();
        const encryptedActiv = this.$refs[this.keyboardData[0].id].getVersion();

        this.loginViewModel.passWord = encryptInputData
        this.loginViewModel.clientRandom = encryptRandomData
        this.loginViewModel.netToken = encryptInputData1
        this.loginViewModel.tokenRandom = encryptRandomData1
        this.loginViewModel.activ = encryptedActiv

      },


      loginBtn() {
        this.getEncryptData()
        this.$refs.loginViewForm.validate(async valid => {
          if (valid) {
            this.loadFlag = true;
            this.buttonAble = true;
            this.loginViewModel.orderReference = window.sessionStorage.getItem('paymentReference');
            await this.$http.post(service.login, this.loginViewModel).then((res) => {
              this.loadFlag = false;
              this.buttonAble = false;

              res['paymentReference'] = res.opxpPaymentNo;
              window.sessionStorage.setItem('sessionToken', res.sessionToken)
              window.sessionStorage.setItem('BuyerOrderDetail', JSON.stringify(res))
              window.sessionStorage.setItem('accounts', JSON.stringify(res.acctList))
              window.sessionStorage.setItem('eTokNum', res.eTokNum)
              this.$router.replace({ name: 'PaymentOne' })
            }).catch(error => {
              window.sessionStorage.setItem('statusCode', "1B")
              window.sessionStorage.setItem('message', "You have cancelled your login.")
              this.loadFlag = false;
              this.buttonAble = false;
              this.dialogVisible = true;
              this.errorMessage = error.message;
              this.loginViewModel.code = ''
              this.getServerRandom();
              this.getCaptcha()
            })

          }
        })
      },



      dialogClose(status) {
        this.dialogVisible = status;
      },

      cancel() {
        this.cancelVisible = true;
      },

      cancelDialogClose(status) {
        this.cancelVisible = false;
      },

      cancelTran() {
        let statusCode = window.sessionStorage.getItem('statusCode');
        if (statusCode == undefined || statusCode == null || statusCode != '1B') {
          window.sessionStorage.setItem('statusCode', "1C")
          window.sessionStorage.setItem('message', "You have cancelled your login.")
        }
        this.cancelVisible = false;
        this.$router.replace({ name: 'ReturnToFpx' })
      }

    }

  }
</script>


<style lang="less" scoped>
  @media screen and (max-width: 330px) {
   div/deep/#divcode div/deep/.el-form-item__error {
      color: #F56C6C;
      font-size: 12px;
      line-height: 1;
      margin-left: 120px;
      position: absolute;
      z-index: -1
    }
    @import "../styles/mobile-i/m_login.less";
  }

  @media screen and (min-width: 331px) and (max-width: 370px) {
   div/deep/#divcode div/deep/.el-form-item__error {
      color: #F56C6C;
      font-size: 12px;
      line-height: 1;
      margin-left: 120px;
      position: absolute;
      z-index: -1;
      margin-top: 10px
    }
    @import "../styles/mobile/m_login.less";
  }

  @media screen and (min-width: 371px) and (max-width: 400px) {
   div/deep/#divcode div/deep/.el-form-item__error {
      color: #F56C6C;
      font-size: 12px;
      line-height: 1;
      margin-left: 120px;
      position: absolute;
      z-index: -1;
      margin-top: 10px
    }
    @import "../styles/mobile_b/m_login.less";
  }

  @media screen and (min-width: 401px) and (max-width: 640px) {
   div/deep/#divcode div/deep/.el-form-item__error {
      color: #F56C6C;
      font-size: 12px;
      line-height: 1;
      margin-left: 120px;
      position: absolute;
      z-index: -1;
      margin-top: 10px
    }
    @import "../styles/mobile_p/m_login.less";
  }

  @media screen and (min-width: 641px) and (max-width: 800px) {
    div/deep/#divcode div/deep/.el-form-item__error {
      color: #F56C6C;
      font-size: 12px;
      line-height: 1;
      margin-left: 260px;
      position: absolute;
      z-index: -1;
      margin-top: 10px
    }
    @import "../styles/pad/login.less";
  }

  @media screen and (min-width: 800px) {
   div/deep/#divcode div/deep/.el-form-item__error {
      color: #F56C6C;
      font-size: 12px;
      line-height: 1;
      margin-left: 250px;
      position: absolute;
      z-index: -1
    }
    @import "../styles/pc/login.less";
  }
</style>



// WEBPACK FOOTER //
// src/views/Login.vue